import { toRGBA } from "./utils";

const koolAid = [250, 71, 71];
const k = (opacity: number = 1) =>
  toRGBA(koolAid[0], koolAid[1], koolAid[2], opacity);

export default k;
